import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const monedaService = {
  getAll,
}

async function getAll() {
  return await ApiBudgety.get('Moneda/GetAll/')
}
